import api from '../lib/api';
import type { Contact, ContactFilterOptions, ContactResponse } from '../types/contact';

class ContactService {
  async getContacts(filters: ContactFilterOptions = {}): Promise<ContactResponse> {
    const response = await api.get('/contacts', { params: filters });
    return response.data;
  }

  async createContact(data: Partial<Contact>): Promise<Contact> {
    try {
      const response = await api.post('/contacts', data);
      return response.data;
    } catch (error) {
      // Pass through the error to be handled by the component
      throw error;
    }
  }

  async getContact(id: number): Promise<Contact> {
    const response = await api.get(`/contacts/${id}`);
    return response.data;
  }

  async updateContact(id: number, data: Partial<Contact>): Promise<Contact> {
    try {
      const response = await api.put(`/contacts/${id}`, data);
      return response.data;
    } catch (error) {
      // Pass through the error to be handled by the component
      throw error;
    }
  }

  async deleteContact(id: number): Promise<void> {
    await api.delete(`/contacts/${id}`);
  }

  async importContacts(file: File): Promise<{
    message: string;
    imported: number;
    skipped: number;
    errors: string[];
  }> {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await api.post('/contacts/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      // Pass through the error to be handled by the component
      throw error;
    }
  }

  async exportContacts(
    channel?: string,
    selectedIds?: number[]
  ): Promise<{
    message: string;
    download_url: string;
    count: number;
  }> {
    const params: any = {};
    if (channel) {
      params.channel = channel;
    }
    if (selectedIds && selectedIds.length > 0) {
      params.ids = selectedIds.join(',');
    }

    const response = await api.get('/contacts/export', { params });
    return response.data;
  }
}

export default new ContactService();
